<app-footer-etl-status-banner></app-footer-etl-status-banner>
<div class="app-footer user-select-none">
  <div class="app-footer__left">
    <span>OPTIMIZE INSIGHTS<sup class="fs-6 p-relative ol-1">TM</sup> {{releaseId}}</span>
  </div>
  <div class="app-footer__center">
  </div>
  <div class="app-footer__right">
    <span>Copyright &copy; TRG Screen, all rights reserved</span>
    <div class="footer-vr"></div>
    <a href="https://www.trgscreen.com/privacy-policy" target="_blank" rel="noopener">Privacy Statement</a>
    <div class="footer-vr"></div>
    <a href="https://www.trgscreen.com/" target="_blank" rel="noopener" class="user-select-none">
      <img class="app-footer__logo" src="../assets/img/trg-logo.svg" alt="TRG Screen" />
    </a>
  </div>
</div>

